var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{domProps:{"textContent":_vm._s(_vm.label)},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.openPayments.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }